import React, { Fragment, useEffect, useState } from "react";
import { Col, Form, Row, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import TextInput from "../../components/InputFields/TextInput";
import { useFormik } from "formik";
import { formikAddClinic, organizationTypeOption } from "./Constant";
import { failed, success } from "../../utils/Tostify";
import { useDispatch, useSelector } from "react-redux";
import { updateClinic } from "../../api/orgnizations";
import Loader from "../../components/Loader/Loader";
import { useGetStates } from "../../hooks/useGetStates";
import "./Organization.css";


const EditClinicModal = ({setShowClinicModal, clinicData, refetch, getUpdatedData}) => {
    let token = useSelector(state => state.userReducer.token);
    const [isLoading, setIsLoading] = useState(false);
    const [Countryvalue, setCountryValue] = useState();
    const [stateValue, setStateValue] = useState();
    const dispatch = useDispatch();
    const { states, countryOptions } = useGetStates(Countryvalue);

    const formik = useFormik({
        ...formikAddClinic,
        onSubmit: async (values) => {
            let res;
            try {
                setIsLoading(true);
                res = await updateClinic({ values, dispatch, token, clinicId: clinicData?._id});
                if (res?.status === "SUCCESS") {
                    await refetch();
                    getUpdatedData(res.data);
                    setIsLoading(false);
                    setShowClinicModal(false);
                    success(res?.message);
                    formik.resetForm();
                }else{
                    setIsLoading(false);
                    setShowClinicModal(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                setShowClinicModal(false);
                failed(res?.message);
            }
        }
    });

    const CountrychangeHandler = e => {
        setCountryValue(e.target.value);
        formik.setFieldValue("country", countryOptions.find((obj) => obj.value === e.target.value).label);
    };

    const stateHandler = (e) => {
        setStateValue(e.target.value);
        formik.setFieldValue('state', e.target.value);
    };

    useEffect(() => {
        if (setShowClinicModal) {
          const modalBody = document.querySelector('.assign_modal_body');
          if (modalBody) {
            modalBody.scrollTop = 0;
          }
        }
      }, [setShowClinicModal]);

    useEffect(() => {
        formik.setFieldValue("clinicName", clinicData?.name);
        formik.setFieldValue("phone", clinicData?.telecom.find((val)=> val.system == "phone")?.value);
        formik.setFieldValue("email", clinicData?.telecom.find((val)=> val.system == "email")?.value);
        formik.setFieldValue("type", clinicData?.type);
        formik.setFieldValue("contactName", clinicData?.contact?.[0]?.name);
        formik.setFieldValue("contactEmail", clinicData?.contact?.[0]?.telecom.find((val)=> val.system == "email")?.value);
        formik.setFieldValue("contactPhone", clinicData?.contact?.[0]?.telecom.find((val)=> val.system == "phone")?.value);
        formik.setFieldValue("address", clinicData?.address?.[0]?.city + "," + clinicData?.address?.[0]?.state);
        formik.setFieldValue("secondaryContactName", clinicData?.contact?.[1]?.name);
        formik.setFieldValue("secondaryContactPhone", clinicData?.contact?.[1]?.telecom.find((val) => val.system == "phone")?.value);
        formik.setFieldValue("secondarycontactEmail", clinicData?.contact?.[1]?.telecom.find((val) => val.system == "email")?.value);
        formik.setFieldValue("postalCode", clinicData?.address?.[0]?.postalCode);
        formik.setFieldValue("city", clinicData?.address?.[0]?.city);
        formik.setFieldValue("country", clinicData?.address?.[0]?.country);
        formik.setFieldValue("orgId", clinicData?.partOf);
        setCountryValue(countryOptions.find((obj) => obj.label === clinicData?.address?.[0]?.country)?.value);
        formik.setFieldValue("state", clinicData?.address?.[0]?.state);
        setStateValue(clinicData?.address?.[0]?.state);
    }, [clinicData]);

  return (
    <Fragment>
            <Modal isOpen={setShowClinicModal} toggle={setShowClinicModal} size="xl">
                <ModalHeader toggle={setShowClinicModal} className="assign_blk">Edit Hospital</ModalHeader>
                <Form onSubmit={formik.handleSubmit}>
                <ModalBody className="assign_modal_body">
                    {isLoading ? <Loader /> : null}
                    <div className="organization_form_block organization_blk organization_modal modal_change_color p-4">
                        <div className="d-flex gap-4">
                            <div className="forms_block">
                                    <div className="first_block">
                                        <Row>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"clinicName"}
                                                    formik={formik}
                                                    label="Hospital Name"
                                                    type="text"
                                                    value={formik.values.clinicName}
                                                    onChange={(e) =>
                                                        formik.setFieldValue("clinicName", e.target.value)
                                                    }
                                                    autoFocus={true}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"orgId"}
                                                    formik={formik}
                                                    label="Part of Organization"
                                                    type="text"
                                                    value={clinicData?.orgName}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"phone"}
                                                    formik={formik}
                                                    label="Phone"
                                                    type="phone"
                                                    value={formik.values.phone}
                                                    onChange={(e) => formik.setFieldValue("phone", e)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"email"}
                                                    formik={formik}
                                                    label="Email"
                                                    type="text"
                                                    value={formik.values.email}
                                                    onChange={(e) => formik.setFieldValue("email", e.target.value)}
                                                />
                                            </Col>
                                        </Row>
                                         <Row className="mb-3">
                                         <Col lg={6} className="location_block location_blk">
                                                <TextInput
                                                    keyField={"type"}
                                                    formik={formik}
                                                    label="Hospital Type"
                                                    type="select"
                                                    options={organizationTypeOption}
                                                    value={formik.values.type}
                                                    onChange={(e) =>formik.setFieldValue("type", e.target.value)}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="first_block">
                                        <Row>
                                            <Col lg={6} className="location_block">
                                                <h6 className="block_name">Primary Contact Person</h6>
                                                <TextInput
                                                    keyField={"contactName"}
                                                    formik={formik}
                                                    label="Name"
                                                    type="text"
                                                    value={formik.values.contactName}
                                                    onChange={(e)=>formik.setFieldValue("contactName", e.target.value)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <h6 className="block_name">
                                                    Secondary Contact Person (Optional)
                                                </h6>
                                                <TextInput
                                                    keyField={"secondaryContactName"}
                                                    formik={formik}
                                                    label="Name"
                                                    type="text"
                                                    required={false}
                                                    placeholder="Full Name"
                                                    value={formik.values?.secondaryContactName}
                                                    onChange={(e) =>formik.setFieldValue("secondaryContactName", e.target.value)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"contactEmail"}
                                                    formik={formik}
                                                    label="Email"
                                                    type="email"
                                                    placeholder="Email"
                                                    value={formik.values.contactEmail}
                                                    onChange={(e) =>formik.setFieldValue("contactEmail", e.target.value)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"secondarycontactEmail"}
                                                    formik={formik}
                                                    label="Email"
                                                    type="email"
                                                    placeholder="Email"
                                                    required={false}
                                                    value={formik.values.secondarycontactEmail}
                                                    onChange={(e) =>formik.setFieldValue("secondarycontactEmail", e.target.value)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"contactPhone"}
                                                    formik={formik}
                                                    label="Phone"
                                                    type="phone"
                                                    placeholder="Phone"
                                                    value={formik.values.contactPhone}
                                                    onChange={(e) => formik.setFieldValue("contactPhone", e)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"secondaryContactPhone"}
                                                    formik={formik}
                                                    label="Phone"
                                                    type="phone"
                                                    placeholder="Phone"
                                                    required={false}
                                                    value={formik.values.secondaryContactPhone}
                                                    onChange={(e) => formik.setFieldValue("secondaryContactPhone", e)}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="first_block second_block">
                                        <h6 className="block_name">Address Information</h6>
                                        <Row>
                                            <Col lg={12} className="location_block">
                                                <TextInput
                                                    keyField={"address"}
                                                    formik={formik}
                                                    label="Street"
                                                    type="text"
                                                    value={formik.values.address}
                                                    onChange={(e) => formik.setFieldValue("address", e.target.value)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"country"}
                                                    formik={formik}
                                                    options={countryOptions}
                                                    label="Country"
                                                    type="select"
                                                    value={Countryvalue}
                                                    onChange={CountrychangeHandler}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"state"}
                                                    formik={formik}
                                                    label="State"
                                                    options={states.map((obj) => {
                                                        return {
                                                            label: obj.name,
                                                            value: obj.name
                                                        };
                                                    })}
                                                    type="select"
                                                    value={stateValue}
                                                    onChange={stateHandler}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"city"}
                                                    formik={formik}
                                                    label="City"
                                                    type="text"
                                                    value={formik.values.city}
                                                    onChange={(e) =>formik.setFieldValue("city", e.target.value)}
                                                />
                                            </Col>
                                            <Col lg={6} className="location_block">
                                                <TextInput
                                                    keyField={"postalCode"}
                                                    formik={formik}
                                                    label="Zip Code"
                                                    type="text"
                                                    value={formik.values.postalCode}
                                                    onChange={(e) =>formik.setFieldValue("postalCode", e.target.value)}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter className="p-0 mt-3">
                    <div className="d-flex justify-content-between">
                        <button className="save_btn" onClick={setShowClinicModal}>Close</button>
                        <button className="save_btn" type="submit">Save</button>
                    </div>
                </ModalFooter>
                </Form>
            </Modal>
        </Fragment>
  );
};

export default EditClinicModal;
